export const getHost = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://excellence-vpn.aslu2183.info';
  }
  return window.location.protocol + '//' + window.location.hostname;
};
